import { render, staticRenderFns } from "./Autocomplete.vue?vue&type=template&id=65e93ef1&scoped=true"
import script from "./Autocomplete.vue?vue&type=script&lang=ts"
export * from "./Autocomplete.vue?vue&type=script&lang=ts"
import style0 from "./Autocomplete.vue?vue&type=style&index=0&id=65e93ef1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e93ef1",
  null
  
)

export default component.exports